import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { Box } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { tenancyChartBars } from "../../../constants";
import { ShaDowBox } from "../../../../../components/boxes";
import { TenancyChart, NoDataCard } from "../../../../../components/parts";
import { defaultItems } from "../../../../../components/parts/graphFooter";
import { currencyFormatter, getData, onlyUniqueValuesInObject } from "../../../../../services";

export const TenantTenancyDataGraph = ({ tId }) => {
  const { id } = useParams();
  const { user } = useSelector((state) => state.auth);
  const currencySymbol = user.currency.symbol;
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    getData(`/praas/v2/buildings/${id}/tenants/${tId}/lease-payments/`, (data) => [
      setChartData([
        {
          title: `${currencyFormatter(data.today, currencySymbol)}/${user.unit_system}`,
          titleColor: COLORS.purple,
          suffix: "(Today)",
          suffixColor: COLORS.purple,
          chartData: [data.monthly],
          name: "Monthly Lease Payment",
          onlyZeroValues: onlyUniqueValuesInObject(data.monthly, 0),
        },
        {
          title: `${currencyFormatter(data.last_year, currencySymbol)}/${user.unit_system}`,
          titleColor: COLORS.purple,
          suffix: "(Last year)",
          suffixColor: COLORS.purple,
          chartData: [data.total],
          name: "Total Lease payments",
          onlyZeroValues: onlyUniqueValuesInObject(data.total, 0),
        },
      ]),
    ]);

    return () => setChartData([]);
  }, []);

  if (!chartData.length) return <NoDataCard />;

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: "46px 24px 24px" }}>
        {chartData.length ? (
          <TenancyChart
            chartData={chartData}
            bars={tenancyChartBars}
            chartStyle={{
              width: 210,
              height: 180,
            }}
            nameStyle={{
              maxWidth: 210,
            }}
            graphFooterItems={[
              {
                name: "Rented units",
                color: COLORS.purple,
              },
              ...defaultItems,
            ]}
            containerStyle={{
              marginBottom: 50,
            }}
          />
        ) : null}
      </Box>
    </ShaDowBox>
  );
};
